import React from "react";
import "./styles/CeoContent.scss";
import { useTranslation } from "react-i18next";

type Segment = {
  text: string;
  highlight?: "yellow" | "green";
};
type Paragraph = {
  segments: Segment[];
};
const CeoContent = () => {
  const { t } = useTranslation();
  const paragraphs = t("aboutUs.ceo.message.paragraphs", { returnObjects: true }) as { lines: string[] }[];
  const medal = t("aboutUs.ceo.medal", { returnObjects: true }) as { imgPath: string; name: string }[];
  const profile = t("aboutUs.ceo.cards.profile", { returnObjects: true }) as string[];
  const career = t("aboutUs.ceo.cards.career", { returnObjects: true }) as string[];
  const education = t("aboutUs.ceo.cards.education", { returnObjects: true }) as string[];
  const awards = t("aboutUs.ceo.cards.awards", { returnObjects: true }) as { text: string; highlight?: boolean }[];
  const leaderShip = t("aboutUs.ceo.cards.leadership.paragraphs", { returnObjects: true }) as Paragraph[];
  const patents = t("aboutUs.ceo.cards.patents", { returnObjects: true }) as string[];
  return (
    <>
      <div id="ceo_content_wrap">
        <div className="title_wrap">
          <h2>CEO’s Message</h2>
          <h2 className="des">{t("aboutUs.ceo.title")}</h2>
        </div>
        <div className="contents">
          <div className="content">
            <div className="left">
              <div className="upper">
                <div className="representative_description_wrap">
                  <div className="position">{t("aboutUs.ceo.representative.position")}</div>
                  <div className="name_ko">{t("aboutUs.ceo.representative.nameKo")}</div>
                  <div className="name_en">{t("aboutUs.ceo.representative.nameEn")}</div>
                </div>
                <div className="img_box">
                  <img src="/imgs/ceo_ljko.png" alt="medal" />
                </div>
              </div>
            </div>
            <div className="right">
              <div className="text_wrap">
                {paragraphs.map((p, i) => (
                  <p key={i}>
                    {p.lines.map((line, j) => (
                      <span key={j}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                ))}
              </div>
            </div>
          </div>
          <div className="card_wrap">
            <div className="card_layer_1">
              <div className="left">
                <div className="card">{t("aboutUs.ceo.cards.title")}</div>
                <div className="card">
                  <ul>
                    {profile.map((item, index) => (
                      <li key={`${item}_${index}`}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="right">
                {medal.map((data, index) => {
                  return (
                    <div className="medal_wrap" key={`${data.imgPath}_${data.name}_${index}`}>
                      <div className="img_box">
                        <img src={data.imgPath} alt="medal" />
                      </div>
                      <div className="name">{data.name}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="card_layer_2">
              <div className="card">
                <ul>
                  {career.map((item, i) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="card">
                <ul>
                  {education.map((item, i) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="card_layer_3">
              <div className="card">
                <ul>
                  {awards.map((item, i) => (
                    <li key={i}>{item.highlight ? <span className="fc_g">{item.text}</span> : item.text}</li>
                  ))}
                </ul>
              </div>
              <div className="card">
                <div className="text">
                  {leaderShip.map((p, i) => (
                    <p key={i}>
                      {p.segments.map((seg, j) =>
                        seg.highlight ? (
                          <span key={j} className={seg.highlight === "yellow" ? "fc_y" : "fc_g"}>
                            {seg.text}
                          </span>
                        ) : (
                          <span key={j}>{seg.text}</span>
                        ),
                      )}
                    </p>
                  ))}
                </div>
              </div>
              <div className="card">
                <ul>
                  {patents.map((item, i) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CeoContent;
